import {SearchRequestDto} from "../../component/user/dto/SearchRequest.dto";

export const GET_USERS = (option: SearchRequestDto, page: number) => `
    query {
        getUsers(isOnlyIndividual: ${option.isOnlyIndividual}, isOnlyBusiness: ${option.isOnlyBusiness}, isOnlyInstitution: ${option.isOnlyInstitution}, keywordType: ${option.keywordType}, keyword: "${option.keyword}", page: ${page}) {
            totalPage
            currentPage
            totalItems
            items {
                seq
                name
                email
                type
                companyName
                businessNumber
                companyType
                licenses {
                    seq
                }
            }
        }
    }
`;

export const GET_USER = (seq: number) => `
    query {
        getUser(seq: ${seq}) {
            seq
            name
            email
            type
            companyName
            businessNumber
            companyType
            thumbnail
            licenses {
                seq
                name
            }
        }
    }
`;